import React, {useState, useEffect, useContext} from "react";
import PropTypes from "prop-types";
import {Box, makeStyles} from "@material-ui/core";
import {ResponsiveDialog} from "@hapinest/theme";
import {ResortsContext} from "../../../store/providers/ResortsProvider";
import {LocaleContext} from "../../../store/providers/LocaleProvider";
import CallUsOptions from "./CallUsOptions";
import CallUsResortList from "./CallUsResortList";
import CallUsResortContactDetails from "./CallUsResortContactDetails";
import CallUsGeneralContactDetails from "./CallUsGeneralContactDetails";
import { useBreakpoints } from "../../../hooks";

const useStyles = makeStyles(() => ({
    dialogContainer: {
        "& .MuiDialogContent-root": {
            paddingTop: "0 !important"
        }
    },
}));

const CallUsDialog = (({isOpen, onClose}) => {
    const classes = useStyles();
    const [resortsStateAndIds, resortsDispatch] = useContext(ResortsContext);
    const {resorts, resortsLoading} = resortsStateAndIds;
    const {localeUppercaseUnderscore} = useContext(LocaleContext)[0];
    const {isExtraSmallScreen} = useBreakpoints();
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [currentStep, setCurrentStep] = useState();
    const [selectedResortId, setSelectedResortId] = useState();
    const [questionId, setQuestionId] = useState();

    useEffect(() => {
        setDialogOpen(isOpen);
        if (isOpen) {
            setCurrentStep(0);
        }
    }, [isOpen]);

    useEffect(() => {
        if (resorts && !resorts.length && !resortsLoading) {
            resortsDispatch({type: "GET_RESORTS_INIT", payload: {locale: localeUppercaseUnderscore, is_bookable: true}});
        }
    }, [resorts]);

    const handleSelectedQuestion = (id) => {
        setCurrentStep(currentStep + 1);
        setQuestionId(id);
    };

    const handleSelectedId = (id) => {
        setSelectedResortId(id);
        setCurrentStep(currentStep + 1);
    };

    const handlePreviousStep = () => {
        setCurrentStep(currentStep - 1);
    };

    const handleCloseDialog = () => {
        onClose();
        setCurrentStep();
        setDialogOpen(false);
    };

    return (
        <ResponsiveDialog
            className={classes.dialogContainer}
            open={isDialogOpen}
            handleClose={handleCloseDialog}
            hasCloseButton
            maxWidth="sm"
            content={(
                <Box
                    mb={3}
                    ml={isExtraSmallScreen() ? 0 : 3}
                    mr={isExtraSmallScreen() ? 0 : 3}
                >
                    {currentStep === 0 && (
                        <CallUsOptions
                            onQuestionCall={handleSelectedQuestion}
                        />
                    )}

                    {currentStep === 1 &&
                        (questionId === "resort-question" ? (
                            <CallUsResortList
                                resorts={resorts}
                                resortsLoading={resortsLoading}
                                onResortChange={(selectedResortId) => handleSelectedId(selectedResortId)}
                                onBackButton={handlePreviousStep}
                            />
                        ) : (
                            <CallUsGeneralContactDetails />
                        ))}

                    {currentStep === 2 && (
                        <CallUsResortContactDetails
                            resortId={selectedResortId}
                        />
                    )}
                </Box>
            )}
        />
    );
});

CallUsDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
};

export default CallUsDialog;
